import { extractAnnotations } from "@code-hike/lighter";
export async function splitAnnotationsAndCode(code, lang, annotationPrefix) {
    let annotations = [];
    let codeWithoutAnnotations = code;
    const { code: newCode, annotations: newAnnotations } = await extractCommentAnnotations(codeWithoutAnnotations, lang, annotationPrefix);
    annotations = [...annotations, ...newAnnotations];
    codeWithoutAnnotations = newCode;
    return { code: codeWithoutAnnotations, annotations };
}
async function extractCommentAnnotations(code, lang, annotationPrefix = "!") {
    const extractor = (comment) => {
        var _a;
        // const regex = /\s*(!?[\w-]+)?(\([^\)]*\)|\[[^\]]*\])?(.*)$/
        const regex = new RegExp(`\\s*(${annotationPrefix}?[\\w-]+)?(\\([^\\)]*\\)|\\[[^\\]]*\\])?(.*)$`);
        const match = comment.match(regex);
        if (!match) {
            return null;
        }
        const name = match[1];
        const rangeString = match[2];
        const query = (_a = match[3]) === null || _a === void 0 ? void 0 : _a.trim();
        if (!name || !name.startsWith(annotationPrefix)) {
            return null;
        }
        return {
            name: name.slice(annotationPrefix.length),
            rangeString,
            query,
        };
    };
    const { code: codeWithoutComments, annotations } = await extractAnnotations(code, lang, extractor);
    return { code: codeWithoutComments, annotations };
}
